// src/validation/studentValidation.js

export const validateStudentForm = (fields) => {
  const errors = {};

  // ------------------- Required Fields -------------------
  const requiredFields = [
    { key: "id_number", label: "ID number" },
    { key: "first_name", label: "First name" },
    { key: "user_name", label: "Username" },
    { key: "program_id", label: "Class" },
    { key: "gender", label: "Gender" },
    { key: "dob", label: "Date of birth" },
    { key: "email", label: "Email" },
    { key: "phone1", label: "Phone number" },
    { key: "father_prefix", label: "Father prefix" },
    { key: "father_first_name", label: "Father first name" },
    { key: "mother_prefix", label: "Mother prefix" },
    { key: "mother_first_name", label: "Mother first name" },
  ];

  requiredFields.forEach(({ key, label }) => {
    if (!fields[key]?.toString().trim()) errors[key] = `${label} is required`;
  });

  // ------------------- Pattern / Format Checks -------------------
  const patterns = [
    { key: "email", regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: "Invalid email format" },
    { key: "phone1", regex: /^\d{10}$/, message: "Phone number must be 10 digits" },
    { key: "aadhar_number", regex: /^\d{12}$/, message: "Aadhar number must be 12 digits" },
  ];

  patterns.forEach(({ key, regex, message }) => {
    if (fields[key] && !regex.test(fields[key].toString().trim())) {
      errors[key] = message;
    }
  });

  if (fields.dob && new Date(fields.dob) > new Date()) errors.dob = "Date of birth cannot be in the future";
  if (fields.vehicle_number?.length > 20) errors.vehicle_number = "Vehicle number cannot exceed 20 characters";
  if (fields.blood_group?.length > 3) errors.blood_group = "Blood group cannot exceed 3 characters";
  if (fields.mode_of_transport?.length > 50) errors.mode_of_transport = "Mode of transport cannot exceed 50 characters";

  // ------------------- Allowed Values -------------------
  const allowedValues = {
    gender: ["male", "female", "transgender"],
    father_prefix: ["Mr.", "Dr."],
    mother_prefix: ["Mrs.", "Ms.", "Dr."],
    guardian_prefix: ["Mr.", "Mrs.", "Ms.", "Dr."],
  };

  Object.entries(allowedValues).forEach(([key, values]) => {
    if (fields[key] && !values.includes(fields[key])) {
      errors[key] = `${key.replace(/_/g, " ")} must be one of ${values.join(", ")}`;
    }
  });

  // ------------------- Conditional Checks -------------------
  if (fields.mode_of_transport  === "bus" && !fields.vehicle_number) {
    errors.vehicle_number = "Vehicle number is required when transport is not self";
  }
  else if (fields.mode_of_transport && fields.mode_of_transport !== "bus") {
    fields.vehicle_number = ""; // Clear vehicle number if transport is self or van
  }

  // ------------------- Image Validation -------------------
  const validateImage = (file) => {
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
    const maxSize = 2 * 1024 * 1024; // 2MB
    if (!file) return null; // no file uploaded
    if (typeof file === "string" && file.startsWith("http")) return null; // skip existing URL
    if (!(file instanceof File)) return "Invalid file";
    if (!allowedTypes.includes(file.type)) return "Allowed image types: jpg, jpeg, png";
    if (file.size > maxSize) return "Image size cannot exceed 2MB";
    return null;
  };

  ["profile_image", "father_profile_pic", "mother_profile_pic", "guardian_profile_pic"].forEach((key) => {
    const err = validateImage(fields[key]);
    if (err) errors[key] = err;
  });

  return errors;
};
